import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import { Fade } from "react-awesome-reveal"

import { useCookieContext } from "../context/Cookie"
import VideoYoutubeModal from "./modals/VideoYoutube"
import RichText from "./richText/Parser"

export default function Iconetextecitationimage({ component }) {
  const {
    iconMedia,
    backgroundcolor,
    button,
    textonright,
    overflowing,
    sideImage,
    title,
    subtitle,
    content,
    backgroundMode,
    videoUrl,
  } = component
  const cookieContext = useCookieContext()
  const youtubePrivacyUrl = cookieContext?.youtubePrivacyUrl || (url => url)

  const [openModal, setOpenModal] = useState(false)

  const poster = {
    src:
      sideImage?.localFile?.childImageSharp?.gatsbyImageData?.images?.sources
        .length > 0 &&
      sideImage?.localFile?.childImageSharp?.gatsbyImageData?.images?.sources[0]
        ?.srcSet,
    altText: sideImage?.altText,
  }

  const hasSideImage =
    component.sideImage?.localFile?.childImageSharp?.gatsbyImageData
  return (
    <div className="relative overflow-hidden">
      <div className="relative">
        {backgroundMode && (
          <div className="absolute inset-0 flex">
            <GatsbyImage
              image={
                component.sideImage?.localFile?.childImageSharp?.gatsbyImageData
              }
              alt={component.sideImage?.alt || ``}
              className="w-full object-center	 object-cover"
            />
          </div>
        )}
        <div
          className={`
          ${backgroundMode ? "relative bg-charlestonGreen-100/70" : ""}
          `}
        >
          <div
            className={`
          relative w-full max-w-7xl px-4 md:px-8 flex  sm:gap-8 lg:gap-24 items-center lg:mx-auto sm:justify-between py-12
          ${!backgroundMode ? "flex-wrap md:flex-nowrap" : ""}
          `}
          >
            <div
              className={` max-w-none mx-0 items-center
              ${textonright ? "order-last" : ""}
              ${overflowing ? "lg:py-16" : ""}
              ${
                hasSideImage && backgroundMode
                  ? "w-full sm:w-3/5 md:w-2/5   p-4  lg:px-6"
                  : ""
              }
              ${hasSideImage && !backgroundMode ? "w-full md:w-3/5 px-0" : ""}
              ${!hasSideImage ? "w-full px-0" : ""}

            `}
            >
              <div className={`${backgroundMode && "max-w-xs"}`}>
                {iconMedia?.localFile?.childImageSharp && (
                  <GatsbyImage
                    className="w-10 h-8 mb-6"
                    image={iconMedia?.localFile.childImageSharp.icon}
                    alt={iconMedia.altText || ""}
                  />
                )}
                <div>
                  {title && (
                    <h2
                      className={`
                    text-3xl font-extrabold tracking-tight mb-3
                    ${
                      backgroundcolor === "blue"
                        ? "text-white"
                        : "text-gray-900"
                    }
                  `}
                    >
                      {title}
                    </h2>
                  )}
                  {subtitle && (
                    <h3
                      className={`tracking-wider text-sm font-light mb-3
                    ${
                      backgroundcolor === "blue"
                        ? "text-white"
                        : "text-grey-700"
                    }
                  `}
                    >
                      {subtitle}
                    </h3>
                  )}
                  {content && (
                    <div
                      className={`prose text-lg ${
                        !hasSideImage ? "max-w-none" : ""
                      }`}
                    >
                      <RichText
                        option="postOptions"
                        stringHtml={content}
                        dark={backgroundcolor === "blue"}
                      />
                    </div>
                  )}
                  <div className="mt-6 -mx-2">
                    {button && (
                      <Link
                        to={button.url}
                        className={`
                        inline-flex mx-2 py-2 px-4 md:px-10 text-base font-medium border shadow-sm btn
                      `}
                      >
                        {button.title}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`mt-12 sm:mt-16 lg:mt-0 
            ${textonright ? "order-first" : ""}
            ${hasSideImage && backgroundMode ? "w-none sm:w-2/5 md:w-3/5" : " "}
            ${
              hasSideImage && !backgroundMode
                ? "md:block mb-8 md:mb-0 md:w-2/5 px-0 "
                : ""
            }
            ${!hasSideImage ? "w-0" : ""}
            `}
            >
              {!backgroundMode && poster.src && (
                <div
                  className={`md:px-4 max-w-lg md:mx-auto lg:px-0 lg:m-0 relative lg:h-full flex items-center 
              ${!backgroundMode ? "lg:relative" : ""}
            `}
                >
                  <Fade>
                    <>
                      {poster.src && (
                        <img
                          className="w-full rounded lg:max-w-none"
                          srcSet={poster.src}
                          alt={poster?.altText}
                        />
                      )}
                      {videoUrl && (
                        <button
                          type="button"
                          className="absolute inset-0 flex items-center justify-center w-full h-full"
                          aria-hidden="true"
                          onClick={() => setOpenModal(true)}
                        >
                          <svg
                            className="w-20 h-20 text-blue-600"
                            fill="currentColor"
                            viewBox="0 0 84 84"
                          >
                            <circle
                              opacity="0.9"
                              cx={42}
                              cy={42}
                              r={42}
                              fill="white"
                            />
                            <path d="M55.5039 40.3359L37.1094 28.0729C35.7803 27.1869 34 28.1396 34 29.737V54.263C34 55.8604 35.7803 56.8131 37.1094 55.9271L55.5038 43.6641C56.6913 42.8725 56.6913 41.1275 55.5039 40.3359Z" />
                          </svg>
                        </button>
                      )}
                    </>
                  </Fade>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {videoUrl && (
        <VideoYoutubeModal
          youtubeUrl={youtubePrivacyUrl(videoUrl)}
          openModal={openModal}
          closeCallback={() => setOpenModal(false)}
        />
      )}
    </div>
  )
}
